import { track } from '@amplitude/analytics-browser';
import { useCallback } from 'react';
import { useLocalStorageStore } from 'store';
import { useShallow } from 'zustand/shallow';

export const useAnalytics = (): {
  trackEvent: (event: string, extraFields?: Record<string, string | number | boolean>, screenName?: string) => void;
} => {
  // const location = useLocation();
  const { userId } = useLocalStorageStore(
    useShallow((state) => ({
      userId: state.userId,
    })),
  );

  const trackEvent = useCallback(
    (event: string, extraFields = {}, internalUserId?: string) => {
      // const screen = screenName || location.pathname.slice(1).replace('-', '_') || 'home';

      const options = {
        user_id: userId,
        ...extraFields,
      };

      track(event, options, internalUserId ? { user_id: internalUserId } : undefined);
    },
    [userId],
  );
  return { trackEvent };
};
